import { useAppSelector } from '@/hook';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getRoute } from './useRouteSection';

export const usePageRedirection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const affiliateState = useAppSelector((state) => state.affiliate);
  const defaultRoute = getRoute(location.pathname);
  const redirect = useMemo(() => {
    return (
      pathname: string,
      options?: {
        countryCode?: string;
        productType?: string;
        entity?: string;
      },
    ) => {
      const { countryCode, productType, entity } = {
        ...defaultRoute,
        ...options,
      };
      // Handle affiliate navigation
      if (
        pathname === 'quotation' &&
        affiliateState.isValid &&
        affiliateState.agentId
      ) {
        pathname = `${pathname}?aid=${affiliateState.agentId}`;
      }

      navigate(`/${countryCode}/${productType}/${entity}/${pathname}`);
    };
  }, []);

  const getHomepageUrl = () => {
    return t('homepage.url', {
      context: affiliateState.isValid && 'agency',
    });
  };

  return { redirect, getHomepageUrl };
};
